import { useState } from 'react';
import ProjectModal from './ProjectModal';

interface Project {
  id: number;
  title: string;
  description: string;
  image: string;
  tags: string[];
  category: string;
  url?: string;
  client?: string;
  year?: string;
  fullDescription?: string;
}

export default function PortfolioGrid() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  const projects: Project[] = [
    {
      id: 1,
      title: "Bamme-Media Branding",
      description: "Komplettes Corporate Design und Branding für meine eigene Webdesign-Agentur.",
      fullDescription: "Komplettes Corporate Design und Branding für meine eigene Webdesign-Agentur. Von Logo-Entwicklung bis hin zu Geschäftsausstattung. Das Projekt umfasste die Entwicklung einer einheitlichen visuellen Identität, die Professionalität und Kreativität vereint.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/6dd493499fb88b80213ff8173a5b958e.jpeg",
      tags: ["Branding", "Logo Design", "Corporate Identity"],
      category: "branding",
      client: "Bamme-Media",
      year: "2024"
    },
    {
      id: 2,
      title: "Musikschule & Musikladen",
      description: "Moderne Website für eine Musikschule mit integriertem Musikladen – übersichtlich, einladend und für alle Altersgruppen.",
      fullDescription: "Professionelle Website für eine Musikschule mit angeschlossenem Musikladen. Das Projekt umfasste die Gestaltung einer einladenden Online-Präsenz mit Kursübersicht, Lehrervorstellung und einem integrierten Shop für Instrumente und Zubehör. Klare Navigation, ansprechendes Design und eine einfache Kontaktmöglichkeit machen die Seite für Schüler, Eltern und Musikbegeisterte gleichermaßen attraktiv.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/a99b5b0666f3f0bd3223b469ea1618d6.jpeg",
      tags: ["Webdesign", "Musikschule", "Online Shop", "Local Business"],
      category: "webdesign",
      client: "Musikschule & Musikladen",
      year: "2025"
    },
    {
      id: 3,
      title: "Allroundservice Website",
      description: "Professionelle Website für einen Allroundservice-Anbieter mit umfassender Servicepräsentation.",
      fullDescription: "Professionelle Website für einen Allroundservice-Anbieter mit umfassender Servicepräsentation und Kontaktmöglichkeiten. Die Website bietet eine klare Struktur und einfache Navigation für alle Dienstleistungen.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/09bc803c235b90e5e9a3fb3111494311.png",
      tags: ["Service Website", "Business", "Multi-Service"],
      category: "webdesign",
      url: "https://www.jo-allround.de",
      client: "JO Allround",
      year: "2024"
    },
    {
      id: 4,
      title: "Tischlerei Hasenbalg",
      description: "Moderne Website für eine traditionelle Tischlerei mit Fokus auf Handwerksqualität und lokaler Präsenz.",
      fullDescription: "Moderne und ansprechende Website für die Tischlerei Hasenbalg – ein Handwerksbetrieb mit langer Tradition. Das Projekt umfasste die Gestaltung einer professionellen Online-Präsenz, die die Handwerkskunst und Qualität des Unternehmens widerspiegelt. Von der Leistungsübersicht bis hin zur Kontaktseite wurde alles auf die Zielgruppe zugeschnitten.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/1cb4daced810ea4cf3811cf04bafe0e6.jpeg",
      tags: ["Webdesign", "Handwerk", "Local Business"],
      category: "webdesign",
      client: "Tischlerei Hasenbalg",
      year: "2025"
    },
    {
      id: 5,
      title: "Hotel Social Media",
      description: "Professionelles Social-Media-Management für ein Hotel – stimmungsvolle Inhalte, die Buchungen und Reichweite steigern.",
      fullDescription: "Umfassendes Social-Media-Management für ein Hotel: Von der Content-Strategie über die Erstellung hochwertiger Bild- und Videoinhalte bis hin zur Community-Pflege. Durch gezielte Kampagnen auf Instagram und Facebook konnte die Reichweite deutlich gesteigert und die Buchungsrate erhöht werden. Monatliche Auswertungen und kontinuierliche Optimierung sichern nachhaltigen Erfolg.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/83273333d18a3b622bf2197813b3793f.jpeg",
      tags: ["Social Media", "Content Creation", "Instagram", "Hotel"],
      category: "social-media",
      client: "Hotel",
      year: "2025"
    },
    {
      id: 6,
      title: "Turbine 19 Social Media",
      description: "Social-Media-Betreuung für die Turbine 19 – industrielle Ästhetik trifft auf modernen Content.",
      fullDescription: "Social-Media-Betreuung für die Turbine 19: Entwicklung einer markanten Content-Strategie, die die industrielle Identität des Unternehmens authentisch transportiert. Erstellung von Reels, Stories und Feed-Posts für Instagram und LinkedIn. Durch konsistentes Branding und zielgruppengerechte Inhalte wurde die Online-Präsenz nachhaltig gestärkt und die Follower-Community aktiv ausgebaut.",
      image: "https://public.readdy.ai/ai/img_res/eaa9581e11ffca6cd0263b24e376897a.jpg",
      tags: ["Social Media", "Content Creation", "Branding", "Industrie"],
      category: "social-media",
      client: "Turbine 19",
      year: "2025"
    }
  ];

  const filters = [
    { id: 'all', label: 'Alle' },
    { id: 'webdesign', label: 'Webdesign' },
    { id: 'social-media', label: 'Social Media' },
    { id: 'foto-video', label: 'Foto & Video' },
    { id: 'branding', label: 'Branding' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category.toLowerCase() === activeFilter);

  const handleProjectClick = (project: Project) => {
    setSelectedProject(project);
  };

  return (
    <>
      <section className="py-20 lg:py-32 bg-black">
        <div className="container mx-auto px-4 sm:px-6">
          
          {/* Filter Buttons */}
          <div className="flex flex-wrap gap-3 lg:gap-4 mb-12 lg:mb-16 pb-12 lg:pb-16 border-b border-white/10">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-5 lg:px-6 py-2 text-xs lg:text-sm uppercase tracking-wider font-light transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeFilter === filter.id
                    ? 'text-[#d1bc8a]'
                    : 'text-white/40 hover:text-white/70'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>

          {/* Portfolio Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {filteredProjects.map((project) => (
              <div 
                key={project.id}
                className="group cursor-pointer"
                onClick={() => handleProjectClick(project)}
              >
                <div className="relative overflow-hidden aspect-[4/3] mb-6">
                  {/* Image */}
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                  />
                  
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black/80 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                    <div className="text-center px-6">
                      <i className="ri-eye-line text-4xl text-[#d1bc8a] mb-4 block"></i>
                      <p className="text-white text-sm uppercase tracking-wider">Projekt ansehen</p>
                    </div>
                  </div>
                </div>

                {/* Project Info */}
                <div>
                  <h3 className="text-xl lg:text-2xl font-bold text-white mb-3 group-hover:text-[#d1bc8a] transition-colors duration-300">
                    {project.title}
                  </h3>
                  <p className="text-white/60 text-sm lg:text-base mb-4 leading-relaxed">
                    {project.description}
                  </p>
                  

                </div>
              </div>
            ))}
          </div>

          {/* Empty State */}
          {filteredProjects.length === 0 && (
            <div className="text-center py-20">
              <i className="ri-time-line text-6xl text-white/20 mb-6 block"></i>
              <p className="text-white/60 text-xl font-light mb-3">Projekte werden bald hinzugefügt</p>

            </div>
          )}

        </div>
      </section>

      {/* Project Modal */}
      {selectedProject && (
        <ProjectModal 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)} 
        />
      )}
    </>
  );
}